import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { Box } from "@mui/material";

import FileCopyRounded from "@material-ui/icons/FileCopyOutlined";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { CONFIG } from "utils/constants";
import { get } from "lodash";
import DashboardCard from "../../../../components/DashboardCard/index";
import { currencyFormat } from "../../../../utils/index";
import {
	invoicesTotalAmountsByDates,
	invoicesTotalVATAmounts,
} from "../../../../redux/actions/invoices/index";

function PaidAndUnpaidInvoice(props) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { dashboardStart, dashboardEnd } = useSelector(({ filterInvoices }) => filterInvoices);
	
	const invoicesTotalAmountsPaid = useSelector(
		({ requests }) =>
			requests.queries.INVOICE_TOTAL_AMOUNT_PAID && requests.queries.INVOICE_TOTAL_AMOUNT_PAID.data
	);
	const invoicesTotalVatAmountsPaid = useSelector(
		({ requests }) =>
			requests.queries.INVOICE_TOTAL_VAT_AMOUNT_PAID &&
			requests.queries.INVOICE_TOTAL_VAT_AMOUNT_PAID.data
	);

	const tenantCountry = useSelector(({ requests }) =>
		get(requests, "queries.FETCH_TENANT_COUNTRY.data")
	);
	const countryConfig = CONFIG[tenantCountry] || CONFIG.MA;

	const invoicesTotalAmountsUnPaid = useSelector(
        ({ requests }) =>
            requests.queries.INVOICE_TOTAL_AMOUNT_UNPAID &&
            requests.queries.INVOICE_TOTAL_AMOUNT_UNPAID.data
    );
    const invoicesTotalAmountsOverdue = useSelector(
        ({ requests }) =>
            requests.queries.INVOICE_TOTAL_OVERDUE_AMOUNT &&
            requests.queries.INVOICE_TOTAL_OVERDUE_AMOUNT.data
    );
	useEffect(() => {
		// dispatch(invoicesTotalAmounts());

		dispatch(invoicesTotalVATAmounts(dashboardStart, dashboardEnd, ["EXPORTED"], "_PAID"));
        dispatch(
            invoicesTotalAmountsByDates(
                dashboardStart,
                dashboardEnd,
                [
                    "INTEGRATION", "TO_VERIFY", "TO_CONTROL", "TO_PAY",
                    "PAYED", "REJECTED", "CANCELED", "EXCEPTION", "TO_VALIDATE_EXTERNAL",
                ],
                "_UNPAID"
            )
        );
	}, [dashboardStart, dashboardEnd]);

	return (
		<DashboardCard
			title={t("invoice.exported")}
			icon={FileCopyRounded}
			secondaryTitle={t("Non exportées")}
			{...props} // eslint-disable-line
		>
			<Grid container spacing={2} justify="center">
				<Grid container item xs={6} spacing={2}>
					<Grid item xs={12}>
						<Typography variant="h5" color="primary" gutterBottom align="center">
							{`${
								invoicesTotalAmountsPaid
									? currencyFormat(invoicesTotalAmountsPaid)
									: currencyFormat(0)
							} ${countryConfig.currency}`}
						</Typography>
						<Typography variant="subtitle2" color="textSecondary" gutterBottom align="center">
							{t("Total amount of invoices")}
						</Typography>
					</Grid>

					<Grid item xs={12}>
						<Typography variant="h5" color="primary" gutterBottom align="center">
							{`${
								invoicesTotalVatAmountsPaid
									? currencyFormat(invoicesTotalVatAmountsPaid)
									: currencyFormat(0)
							} ${countryConfig.currency}`}
						</Typography>
						<Typography variant="subtitle2" color="textSecondary" gutterBottom align="center">
							{t("Total VAT amount")}
						</Typography>
					</Grid>
				</Grid>
				<Grid item xs={6} className="p-relative">
					<Divider orientation="vertical" absolute />

					<Box style={{ width: '100%', padding: '0 16px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                        <Box mb={2} width="100%">
                            <Typography variant="h5" color="primary" gutterBottom align="center">
                                {invoicesTotalAmountsUnPaid && invoicesTotalAmountsUnPaid !== ""
                                    ? `${currencyFormat(invoicesTotalAmountsUnPaid)} ${countryConfig.currency}`
                                    : `${currencyFormat(0)} ${countryConfig.currency}`}
                            </Typography>
                            <Typography variant="subtitle2" color="textSecondary" gutterBottom align="center">
                                {t("Total amount of invoices")}
                            </Typography>
                        </Box>
                        
                        <Box width="100%">
                            <Typography variant="h5" color="error" gutterBottom align="center">
                                {invoicesTotalAmountsUnPaid && invoicesTotalAmountsOverdue !== ""
                                    ? `${currencyFormat(invoicesTotalAmountsOverdue)} ${countryConfig.currency}`
                                    : `${currencyFormat(0)} ${countryConfig.currency}`}
                            </Typography>
                            <Typography variant="subtitle2" color="textSecondary" gutterBottom align="center">
                                {t("Late")}
                            </Typography>
                        </Box>
                    </Box>
				</Grid>
			</Grid>
		</DashboardCard>
	);
}

export default PaidAndUnpaidInvoice;
